import moment from "moment";
export const titleWeb = "Tổng đài đặt sân golf (wBooking)";
export function sendEvenGA(eventName, data) {
  let dataGtag = {
    ...data,
    access_time: moment().format("YYYY-MM-DD HH:mm:ss")
  };

  gtag("event", eventName, dataGtag);
  return dataGtag;
}
